import { Icon } from '../Icon/Icon';
import s from './Toast.module.css';

type ToastProps = {
  title: string;
  body?: string;
  /** Error toasts use role="alert" (assertive); success uses role="status". */
  error?: boolean;
};

export function Toast({ title, body, error = false }: ToastProps) {
  return (
    <div className={`${s.toast} ${error ? s.error : ''}`} role={error ? 'alert' : 'status'}>
      <Icon name={error ? 'alert' : 'check'} size={22} className={s.icon} />
      <div className={s.text}>
        <span className={s.title}>{title}</span>
        {body && <span className={s.body}>{body}</span>}
      </div>
    </div>
  );
}
